import { computed, ref } from 'vue'

/*
 * Module-scoped so every caller (topbar pill, keybinding, palette component)
 * shares the same open/close state without needing a store.
 */
const isOpen = ref(false)

/**
 * Global state for the command palette (⌘K / Ctrl+K). The palette component itself
 * lives in the authenticated layout; anything else only needs `open()` and the
 * platform-specific shortcut label.
 */
export function useCommandPalette() {
  const isMac = typeof navigator !== 'undefined' && /Mac|iPhone|iPad/.test(navigator.platform)

  /** Human-readable shortcut for kbd hints, e.g. "⌘ K" or "Ctrl K". */
  const shortcutLabel = computed(() => (isMac ? '⌘ K' : 'Ctrl K'))

  function open() {
    isOpen.value = true
  }

  function close() {
    isOpen.value = false
  }

  function toggle() {
    isOpen.value = !isOpen.value
  }

  return {
    isOpen,
    shortcutLabel,
    open,
    close,
    toggle,
  }
}
